import Konva from "konva";

export const toCapitalize = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const isArrayEquals = (
	array1: number[] | string[],
	array2: number[] | string[],
) => {
	return (
		array1.length == array2.length &&
		array1.every(function (element, index) {
			return (
				element === array2[index] ||
				array2.find(elem => elem === element)
			);
		})
	);
};

type coord = {x: number, y: number};
const rotatePoint = ({ x, y }: coord, rad: number) => {
	const rcos = Math.cos(rad);
	const rsin = Math.sin(rad);
	return { x: x * rcos - y * rsin, y: y * rcos + x * rsin };
};
  
export const rotateAroundCenter = (node: any, rotation: number, pivotNode?: any) => {
	let n = node;

	if(pivotNode){
		n = pivotNode;
	}

	const topLeft = { x: -n.width() / 2, y: -n.height() / 2 };
	const current = rotatePoint(topLeft, Konva.getAngle(node.rotation()));
	const rotated = rotatePoint(topLeft, Konva.getAngle(rotation));
	const dx = rotated.x - current.x;
	const dy = rotated.y - current.y;
	
	node.rotation(rotation);
	node.x(node.x() + dx);
	node.y(node.y() + dy);
}

export const localStorageItem = (key: string) => {
	const data = localStorage.getItem(key);

	if (data) {
		return JSON.parse(data);
	}

	return null;
}

export const getRandomUUID = () => {
  let answer =  "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );

  return answer;
}

export const getDigFromString = (item: number | string) => {
  if (typeof item === 'number') {
    return item
  }

  const answer = parseInt(item?.replace(/[^\d]/g, ''));
  if (!item?.trim() || isNaN(answer)) {
    return 0;
  }

  return parseInt(item.replace(/[^\d]/g, ''))
}